/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface McsConfigResponse
 */
export interface McsConfigResponse {
    /**
     * 
     * @type {number}
     * @memberof McsConfigResponse
     */
    locationId: number;
    /**
     * 
     * @type {number}
     * @memberof McsConfigResponse
     */
    minimumMonths: number;
    /**
     * 
     * @type {number}
     * @memberof McsConfigResponse
     */
    maximumMonths: number;
    /**
     * 
     * @type {number}
     * @memberof McsConfigResponse
     */
    minimumDeliveryLeadDays: number;
}

/**
 * Check if a given object implements the McsConfigResponse interface.
 */
export function instanceOfMcsConfigResponse(value: object): value is McsConfigResponse {
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('minimumMonths' in value) || value['minimumMonths'] === undefined) return false;
    if (!('maximumMonths' in value) || value['maximumMonths'] === undefined) return false;
    if (!('minimumDeliveryLeadDays' in value) || value['minimumDeliveryLeadDays'] === undefined) return false;
    return true;
}

export function McsConfigResponseFromJSON(json: any): McsConfigResponse {
    return McsConfigResponseFromJSONTyped(json, false);
}

export function McsConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): McsConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': json['locationId'],
        'minimumMonths': json['minimumMonths'],
        'maximumMonths': json['maximumMonths'],
        'minimumDeliveryLeadDays': json['minimumDeliveryLeadDays'],
    };
}

export function McsConfigResponseToJSON(json: any): McsConfigResponse {
    return McsConfigResponseToJSONTyped(json, false);
}

export function McsConfigResponseToJSONTyped(value?: McsConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': value['locationId'],
        'minimumMonths': value['minimumMonths'],
        'maximumMonths': value['maximumMonths'],
        'minimumDeliveryLeadDays': value['minimumDeliveryLeadDays'],
    };
}

